// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, COMMON_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/member'

const MEMBER = () => {
    return {
        memberGb: null,
        userName: null,
        userId: null,
        clientNo: null,
        clientNm: null,
        nickname: null,
        mobileNo: null,
        birthyyMmday: null,
        gender: null,
        genderNm: null,
        email: null,
        hmUseYn: 'N',
        smsRecvYn: 'N',
        emailRecvYn: 'N',
        joinKind: null,
        provider: null,
        jobName: null,
        pstName: null,
        depart: null,
        jobNo: null,
        pstNo: null,
        pushRecvYn: 'N',
        appRunningRecvYn: 'N',
        realtalkRecvYn: 'N',
        nightTimeRecvYn: 'N',
        tutorial: false,
        missionTutorial: false,
        atvtYn: null
    }
}

const state = {
    member: MEMBER()
}

const mutations = {
    setMemberInfo(state, form) {
        if (form.memberGb) state.member.memberGb = form.memberGb;
        if (form.userName) state.member.userName = form.userName;
        if (form.userId) state.member.userId = form.userId;
        if (form.clientNo) state.member.clientNo = form.clientNo;
        if (form.clientNm) state.member.clientNm = form.clientNm;
        if (form.nickname) state.member.nickname = form.nickname;
        if (form.mobileNo) state.member.mobileNo = form.mobileNo;
        if (form.birthyyMmday) state.member.birthyyMmday = form.birthyyMmday;
        if (form.gender) state.member.gender = form.gender;
        if (form.genderNm) state.member.genderNm = form.genderNm;
        if (form.email) state.member.email = form.email;
        if (form.hmUseYn) state.member.hmUseYn = form.hmUseYn;
        if (form.smsRecvYn) state.member.smsRecvYn = form.smsRecvYn;
        if (form.emailRecvYn) state.member.emailRecvYn = form.emailRecvYn;
        if (form.joinKind) state.member.joinKind = form.joinKind;
        if (form.provider) state.member.provider = form.provider;
        if (form.jobName) state.member.jobName = form.jobName;
        if (form.pstName) state.member.pstName = form.pstName;
        if (form.depart) state.member.depart = form.depart;
        if (form.jobNo) state.member.jobNo = form.jobNo;
        if (form.pstNo) state.member.pstNo = form.pstNo;
        if (form.pushRecvYn) state.member.pushRecvYn = form.pushRecvYn;
        if (form.appRunningRecvYn) state.member.appRunningRecvYn = form.appRunningRecvYn;
        if (form.realtalkRecvYn) state.member.realtalkRecvYn = form.realtalkRecvYn;
        if (form.nightTimeRecvYn) state.member.nightTimeRecvYn = form.nightTimeRecvYn;
        if (form.tutorial) state.member.tutorial = form.tutorial;
        if (form.missionTutorial) state.member.missionTutorial = form.missionTutorial;
        if (form.atvtYn) state.member.atvtYn = form.atvtYn;
    },
    initMemberInfo(state) {
        state.member = MEMBER();
    }
}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {

    /**
     * 회원정보 조회
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async getMemberInfo ({commit}, payload) {
        return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}`)
            .then(res => {
                if (res.success) {
                    commit('setMemberInfo', res.data)
                } else {
                    commit('initMemberInfo')
                }
            })
    },


    /**
     * 회원 > 알림설정
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setAdvertInfoRecvYn ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/advertInfo-recv-yn`, payload)
    },

	/**
	 * 회원 > 임직원정보 조회
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async updateEmployee ({commit}, payload) {
		return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/employee-update`, payload)
	},

	/**
	 * 회원 > 임직원정보 조회
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async passwordCheck ({commit}, payload) {
		return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/password-check`, payload)
	},

	/**
	 * 회원 > 임직원정보 조회
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async getEmployeeInfo ({commit}, payload) {
		return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/getEmployeeInfo`, payload)
	},

    /**
     * 회원 > 회원탈퇴
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setMemberSecession ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/secession`, payload)
    },

    /**
     * 회원 > 회원가입 > 닉네임 중복검사
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async getUserReduNickname ({commit}, payload) {
        return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/nickname-redu/{nickname}`, payload)
    },

    /**
     * 회원 > 회원정보 변경 > 닉네임 변경
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setMemberInfo ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/info/modify`, payload)
    },


    /**
     * 회원 > 메인 > 알람 리스트
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async getMemberAlarmList ({commit}, payload) {
        return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/alarm/{memberNo}`, payload)
    },

    /**
     * 회원 > 메인 > 알람 리스트 확인 변경
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setMemberAlarmCheck ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/alarm-check`, payload)
    },

    /**
     * 회원 > 메인 > 알람 등록
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setMemberAlarm ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/alarm`, payload)
    },

    /**
     * 회원 > 회원가입 > 임시 회원 저장
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setMemberInsert ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/temp-join`, payload)
    },

    /**
     * 회원 > 온보딩 확인 여부 변경
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setObdCheckYn ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/obd-check`, payload)
    },

    /**
     * 회원 > 여행지원서 알림 일자 변경
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setTravelapplAlarmDt ({commit}) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/travel-alarm`)
    },

    /**
     * 회원 > 메인 > 새알람 갯수
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async getMemberNewAlarmCnt ({commit}, payload) {
        return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/alarm/new-alarm/{memberNo}`, payload)
    },

    /**
     * 회원 > 알림설정
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async setRecvYn ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/revc-yn`, payload)
    },

    /**
	 * 회원 > 내정보관리 이미지 변경
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async putProfileAtchNo ({commit}, payload) {
		return transmission(true, WEB_METHODS.PUT, `${USER_ROOT + ROOT}/profile/{profileAtchFileName}`, payload)
	},

    /**
     * 회원 > 메인 튜토리얼 > 시작하기
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async checkTutorial ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/check-tutorial`)
    },

    /**
     * 회원 > 메인 튜토리얼 > 시작하기
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async checkMissionTutorial ({commit}, payload) {
        return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/check-mission-tutorial`)
    }
}

const getters = {
    member (state) {
        return state.member
    }
}

export default { state, mutations, actions, getters }
